import { render } from "./CeciliaCharacter.vue?vue&type=template&id=4750b17e&scoped=true"
import script from "./CeciliaCharacter.vue?vue&type=script&lang=js"
export * from "./CeciliaCharacter.vue?vue&type=script&lang=js"

import "./CeciliaCharacter.vue?vue&type=style&index=0&id=4750b17e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4750b17e"]])

export default __exports__